import React, { useState } from "react";
import { customerApi, apiError, gbp } from "@/lib/customerApi";

export default function PicksSection({ me, catalog, preselect, onSaved }) {
  const [sel, setSel] = useState(() => {
    const cur = me.picks.map((p) => p.store_id);
    return preselect && !cur.includes(preselect) && (me.pick_limit == null || cur.length < me.pick_limit) ? [...cur, preselect] : cur;
  });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const lim = me.pick_limit;
  const toggle = (id) => setSel(sel.includes(id) ? sel.filter((x) => x !== id) : lim != null && sel.length >= lim ? sel : [...sel, id]);
  const save = async () => {
    setBusy(true); setErr("");
    try {
      const { data } = await customerApi.post("/store/account/picks", { store_ids: sel });
      onSaved(data);
    } catch (e) {
      setErr(apiError(e));
    } finally {
      setBusy(false);
    }
  };
  if (!me.subscription?.active) {
    return (
      <section data-testid="picks-section-locked" className="border border-blue-900/40 bg-[#020617]/40 rounded-xl p-6 opacity-80">
        <div className="mono text-[10px] uppercase tracking-widest text-[#FBBF24]">Step 2 · pick your bots</div>
        <p className="text-sm text-[#94A3B8] mt-2">
          Once your plan is active you'll tick the bots you want here - 1, 5 or all of them, depending on your plan.
        </p>
        <a href="/mt5#bots" data-testid="picks-browse-link" className="inline-block mt-3 mono text-[10px] uppercase tracking-widest text-[#38BDF8] hover:text-white">Browse the bots →</a>
      </section>
    );
  }
  return (
    <section data-testid="picks-section" className="border border-blue-900/40 bg-[#020617]/70 rounded-xl p-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="mono text-[10px] uppercase tracking-widest text-[#FBBF24]">Step 2 · pick your bots</div>
          <div className="text-xs text-[#94A3B8] mt-1" data-testid="picks-counter">
            {sel.length} of {lim == null ? "unlimited" : lim} selected · {me.unlimited_swaps ? "unlimited swaps (founder/tester account)" : `you can swap once per billing cycle${me.swap_used_this_period ? " (used)" : ""}`}
          </div>
        </div>
        <button onClick={save} disabled={busy} data-testid="picks-save-btn" className="mono text-[11px] uppercase tracking-widest px-5 py-2.5 rounded-lg bg-[#38BDF8] text-[#050914] disabled:opacity-50">
          {busy ? "Saving…" : "Save picks"}
        </button>
      </div>
      {err && <div className="text-xs text-[#F87171] mt-3" data-testid="picks-error">{err}</div>}
      <div className="mt-5 space-y-5 max-h-[460px] overflow-y-auto pr-1">
        {(catalog?.symbols || []).map((s) => (
          <div key={s.symbol}>
            <div className="mono text-[10px] uppercase tracking-widest text-[#64748B]">{s.symbol} · {s.symbol_name}</div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2">
              {s.bots.map((b) => {
                const on = sel.includes(b.store_id);
                return (
                  <label key={b.store_id} data-testid={`pick-option-${b.store_id}`} className={`flex items-center gap-3 border rounded-lg px-3 py-2.5 cursor-pointer transition-colors ${on ? "border-[#38BDF8] bg-[#38BDF8]/10" : "border-blue-900/40 hover:border-blue-700"}`}>
                    <input type="checkbox" checked={on} onChange={() => toggle(b.store_id)} className="accent-[#38BDF8]" />
                    <span className="flex-1 text-sm">{b.name}</span>
                    <span className="text-xs text-[#2ECA7F]">{gbp(b.avg_monthly)}/mo</span>
                    <a href={`/mt5/bot/${b.store_id}`} target="_blank" rel="noreferrer" className="mono text-[10px] text-[#94A3B8] hover:text-white">details</a>
                  </label>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
